import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ErrorInterceptor } from './error.interceptor';
import { InjectTokenInterceptor } from './inject-token.interceptor';

export const interceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: InjectTokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
]
